// firebase config
export const firebaseConfig = {
    apiKey: "AIzaSyAumlA5NYCTKct-3xU39UCpvfOlxO6E-q4",
    authDomain: "catalogue-34568.firebaseapp.com",
    projectId: "catalogue-34568",
    storageBucket: "catalogue-34568.appspot.com",
    messagingSenderId: "271242773819",
    appId: "1:271242773819:web:b6b7008f9b49f277e4231e",
    measurementId: "G-9FX7WPNFT5"
};